"use strict";
/*
 * Copyright 2019 NEM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _classCallCheck = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RestrictionMosaicHttp = void 0;

var symbol_openapi_typescript_fetch_client_1 = require("symbol-openapi-typescript-fetch-client");

var utils_1 = require("../core/utils");

var model_1 = require("../model");

var mosaic_1 = require("../model/mosaic");

var restriction_1 = require("../model/restriction");

var Http_1 = require("./Http");

var paginationStreamer_1 = require("./paginationStreamer");
/**
 * RestrictionMosaic http repository.
 *
 * @since 1.0
 */


var RestrictionMosaicHttp = /*#__PURE__*/function (_Http_1$Http) {
  _inherits(RestrictionMosaicHttp, _Http_1$Http);

  var _super = _createSuper(RestrictionMosaicHttp);

  /**
   * Constructor
   * @param url Base catapult-rest url
   * @param fetchApi fetch function to be used when performing rest requests.
   */
  function RestrictionMosaicHttp(url, fetchApi) {
    var _this;

    _classCallCheck(this, RestrictionMosaicHttp);

    _this = _super.call(this, url, fetchApi);
    _this.restrictionMosaicRoutesApi = new symbol_openapi_typescript_fetch_client_1.RestrictionMosaicRoutesApi(_this.config());
    return _this;
  }
  /**
   * Returns a mosaic restrictions page based on the criteria.
   *
   * @param criteria the criteria
   * @return a page of {@link MosaicRestriction}
   */


  _createClass(RestrictionMosaicHttp, [{
    key: "search",
    value: function search(criteria) {
      var _this2 = this;

      var _a, _b, _c;

      return this.call(this.restrictionMosaicRoutesApi.searchMosaicRestrictions((_a = criteria.mosaicId) === null || _a === void 0 ? void 0 : _a.toHex(), (_b = criteria.entryType) === null || _b === void 0 ? void 0 : _b.valueOf(), (_c = criteria.targetAddress) === null || _c === void 0 ? void 0 : _c.plain(), criteria.pageSize, criteria.pageNumber, criteria.offset, utils_1.DtoMapping.mapEnum(criteria.order)), function (body) {
        return _get(_getPrototypeOf(RestrictionMosaicHttp.prototype), "toPage", _this2).call(_this2, body.pagination, body.data, function (r) {
          return RestrictionMosaicHttp.toMosaicRestriction(r);
        });
      });
    }
  }, {
    key: "streamer",
    value: function streamer() {
      return new paginationStreamer_1.RestrictionMosaicPaginationStreamer(this);
    }
    /**
     * This method maps a mosaic restriction dto from rest to the SDK's model object.
     *
     * @internal
     * @param {MosaicAddressRestrictionDTO | MosaicGlobalRestrictionDTO} dto the restriction object from rest.
     * @returns {MosaicRestriction} a restriction model
     */

  }, {
    key: "getMosaicRestrictions",
    value: function getMosaicRestrictions(compositeHash) {
      return this.call(this.restrictionMosaicRoutesApi.getMosaicRestrictions(compositeHash), RestrictionMosaicHttp.toMosaicRestriction);
    }
  }, {
    key: "getMosaicRestrictionsMerkle",
    value: function getMosaicRestrictionsMerkle(compositeHash) {
      return this.call(this.restrictionMosaicRoutesApi.getMosaicRestrictionsMerkle(compositeHash), utils_1.DtoMapping.toMerkleStateInfo);
    }
  }], [{
    key: "toMosaicRestriction",
    value: function toMosaicRestriction(dto) {
      if (dto.mosaicRestrictionEntry.targetAddress) {
        var addressRestrictionDto = dto;
        return new restriction_1.MosaicAddressRestriction(dto.mosaicRestrictionEntry.version || 1, dto.mosaicRestrictionEntry.compositeHash, dto.mosaicRestrictionEntry.entryType.valueOf(), new mosaic_1.MosaicId(dto.mosaicRestrictionEntry.mosaicId), utils_1.DtoMapping.toAddress(addressRestrictionDto.mosaicRestrictionEntry.targetAddress), addressRestrictionDto.mosaicRestrictionEntry.restrictions.map(RestrictionMosaicHttp.toMosaicAddressRestrictionItem));
      }

      var globalRestrictionDto = dto;
      return new restriction_1.MosaicGlobalRestriction(dto.mosaicRestrictionEntry.version || 1, dto.mosaicRestrictionEntry.compositeHash, dto.mosaicRestrictionEntry.entryType.valueOf(), new mosaic_1.MosaicId(dto.mosaicRestrictionEntry.mosaicId), globalRestrictionDto.mosaicRestrictionEntry.restrictions.map(function (i) {
        return RestrictionMosaicHttp.toMosaicGlobalRestrictionItem(i);
      }));
    }
  }, {
    key: "toMosaicGlobalRestrictionItem",
    value: function toMosaicGlobalRestrictionItem(restriction) {
      return new restriction_1.MosaicGlobalRestrictionItem(model_1.UInt64.fromNumericString(restriction.key), new mosaic_1.MosaicId(restriction.restriction.referenceMosaicId), model_1.UInt64.fromNumericString(restriction.restriction.restrictionValue), restriction.restriction.restrictionType.valueOf());
    }
  }, {
    key: "toMosaicAddressRestrictionItem",
    value: function toMosaicAddressRestrictionItem(restriction) {
      return new restriction_1.MosaicAddressRestrictionItem(model_1.UInt64.fromNumericString(restriction.key), model_1.UInt64.fromNumericString(restriction.value));
    }
  }]);

  return RestrictionMosaicHttp;
}(Http_1.Http);

exports.RestrictionMosaicHttp = RestrictionMosaicHttp;